import { DegreeType, Lang } from "../types/general";

export const AppStrings = {
    [Lang.he]: {
        appTitle: "מחשבון הקלות",
        appSubTitle: 'מחשבון זה מציג את ההקלות המותאמות לשנת הלימודים תשפ"ה כפי שמופרט ',
        // appSubTitle: "מחשבון זה מתבסס על שני מתווים, מתווה האוניברסיטה ומתווה המועצה להשכלה גבוהה- המל\"ג, המפורטים ", 
        appSubTitle2: "",
        // appSubTitle2: " במקרה של שוני בין שני המתווים, האפשרות המקילה ביותר מודגשת בכל מרכיב.",
        studentInMiluim: "סטודנט/ית במילואים",
        mateOfMiluim: "סטודנט/ית בן/בת זוג למשרת/ת במילואים",
        pleaseFill: "אנא בחרו:",
        degreeType: "לומד/לומדת לתואר",
        [DegreeType.Boger]: "תואר בוגר",
        [DegreeType.Musmach]: "תואר מוסמך",
        [DegreeType.DentalBogerShanaA]: "בוגר שנה א'",
        [DegreeType.DentalBogerShanaB]: "בוגר שנה ב'",
        [DegreeType.DentalBogerShanaC]: "בוגר שנה ג'",
        [DegreeType.DentalDoctorShanaD]: "קלינית שנה ד'",
        [DegreeType.DentalDoctorShanaE]: "קלינית שנה ה'",
        [DegreeType.DentalDoctorShanaF]: "קלינית שנה ו'",
        [DegreeType.DentalMusmach]: "מוסמך",
        [DegreeType.BschoolMaslulMuatz]: "מסלול מואץ/אלפא (הכנה למוסמך)",
        miluimPeriods: "תקופות שירות מילואים",
        periods: "תקופות השרות:",
        add: "הוספה",
        from: "החל מ",
        to: "עד",
        calc: "חישוב",
        result: "תוצאות החישוב",
        course: "זכאות למספר קורסים עם ציון בינארי:",
        NekudotZehut: "זכאות לפטור מנקודות זכות:",
        AvneyPina: "זכאות לפטור מנקודות זכות בקורסי אבני פינה:",
        examDoesntCount: "זכאות לא להגיש טופס בחינה במועד נוסף בקורס, במידה וכבר נגשת למועד אחד באותו הקורס",
        getHighestGrade: "זכאות לבחירת הציון הגבוה מבין שני מועדי בחינה בקורס או אפשרות לא להגיש טופס בחינה במועד נוסף באותו קורס (שנגשת כבר למועד אחד בו)",
        testTimeExtension: "תוספת זמן של 25% בבחינות",
        noAttendanceRequired: "סטודנט אשר נעדר משיעורים במהלך השנה עקב מילואים, היעדרות זו לא תיחשב עבורו כמי שלא עמד בחובת הנוכחות, על כל המשתמש מכך, כמפורט בסילבוס הקורס. למשל: בסילבוס הקורס ישנה דרישה של נוכחות ב85 אחוז מהשיעורים כתנאי לגשת למבחן. סטודנט שלא עמד בתנאי זה עקב שירות מילואים, יוכל לגשת לבחינה.",
        intermediateAssignmentsPtor: "זכאים לפטור מהגשת מטלות ביניים בקורס בו יש מטלה מסכמת שמשקלה לפחות 70% מהציון הסופי",
        ptorMandatoryAttendance: "פטור מחובת נוכחות",
        alternativeAssessment: "שלושה קורסים עם הערכה חלופית (למעט רפואה, מקצועות הבריאות והנדסה)",
        noRights: "לא נמצאו הקלות",
        RefuaChishuvit: 'רפואה חישובית',
        DoubleDegree: 'תואר כפול מעל 150 נ"ז',
        DoubleDegreeMalagComment: 'הקלות המל"ג תקפות על תואר בוגר אחד בלבד',
        here: "כאן.",
        days: "ימים",
        datesOverlapping: "תאריכים חופפים או לא תקינים",
        OnlyWithChildren: "עם ילד/ים מתחת לגיל 13",
        inCaseOfContradiction: "במקרה של סתירה או אי התאמה בין תוצאות המחשבון לבין ",
        rulesLinkIsImportant: ", יגבר האמור בדף הכללים.",
        inCaseOfMistake: "במקרה של באג או תקלה נא לפנות ל ",
        inCaseOfCalcMistake: "לשאלות בקשר לחישוב נא לפנות למזכירות הפקולטה. בעיות טכניות ניתן לדווח ב - ",
        orFinishedMiluim: "או שסיים/סיימה את שירות המילואים",
        rules: "הכללים",
        consultant: "יועצי המילואים",
        anyOtherIssue: "עבור פניות אישיות ניתן לפנות ל",
        clear: "איפוס",
        hachraga10nekodotZcootComment: '* סטודנטים הלומדים לתואר ברפואה, מקצועות הבריאות, הנדסה (למעט החוג להנדסת חשמל ומדעי המחשב) או מקצועות שיש בהם חובת רישוי (למעט הוראה) זכאים להפחתה של 8 נקודות זכות במקום 10',
        // HUM
        askForPersonal1: "להגשת ",
        askForPersonal2: "בקשה",
        askForPersonal3: " להתאמות אקדמאיות.",
        forAnyQuestion: "בכל שאלה ניתן לפנות ",
        miluimConsultant: "לנציגת המילואים",
        ofHUM: " של הפקולטה למדעי הרוח."

    },
    [Lang.en]: {
        appTitle: "Academic Rights Calculator",
        appSubTitle: "Calculator is based on the instrunctions detaild",
        appSubTitle2: "",
        studentInMiluim: "I am a student in Miluim",
        mateOfMiluim: "I am a spouse of somebody in Miluim",
        pleaseFill: "Please fill in:",
        degreeType: "Studying for ",
        [DegreeType.Boger]: "Bachelor's degree",
        [DegreeType.Musmach]: "Master’s Degree",
        [DegreeType.DentalBogerShanaA]: "",
        [DegreeType.DentalBogerShanaB]: "",
        [DegreeType.DentalBogerShanaC]: "",
        [DegreeType.DentalDoctorShanaD]: "",
        [DegreeType.DentalDoctorShanaE]: "",
        [DegreeType.DentalDoctorShanaF]: "",
        [DegreeType.DentalMusmach]: "",
        [DegreeType.BschoolMaslulMuatz]: "מסלול מואץ/אלפא (הכנה למוסמך)",
        miluimPeriods: "Miluim service periods",
        add: "Add",
        from: "From",
        to: "To",
        periods: "Miluim periods",
        calc: "Calculate",
        result: "Calculation results",
        course: "Course",
        NekudotZehut: "Nekudot Zehut",
        AvneyPina: "זכאות לפטור מנקודות זכות בקורסי אבני פינה:",
        examDoesntCount: "זכאות לא להגיש טופס בחינה במועד נוסף בקורס, במידה וכבר נגשת למועד אחד באותו הקורס",
        getHighestGrade: "זכאות לבחירת הציון הגבוה מבין שני מועדי בחינה בקורס או אפשרות לא להגיש טופס בחינה במועד נוסף באותו קורס (שנגשת כבר למועד אחד בו)",
        testTimeExtension: "תוספת זמן של 25% בבחינות",
        noAttendanceRequired: "סטודנט אשר נעדר משיעורים במהלך, השנה עקב מילואים, היעדרות זו לא תיחשב עבורו כמי שלא עמד בחובת הנוכחות, על כל המשתמש מכך, כמפורט בסילבוס הקורס. למשל: בסילבוס הקורס ישנה דרישה של נוכחות ב85 אחוז מהשיעורים כתנאי לגשת למבחן. סטודנט שלא עמד בתנאי זה עקב שירות מילואים, יוכל לגשת לבחינה.",
        intermediateAssignmentsPtor: "זכאים לפטור מהגשת מטלות ביניים בקורס בו יש מטלה מסכמת שמשקלה לפחות 70% מהציון הסופי",
        ptorMandatoryAttendance: "פטור מחובת נוכחות",
        alternativeAssessment: "שלושה קורסים עם הערכה חלופית (למעט רפואה, מקצועות הבריאות והנדסה)",
        noRights: "No rights were found",
        RefuaChishuvit: "Computational medicine",
        DoubleDegree: "",
        DoubleDegreeMalagComment: '',
        here: "here.",
        days: "days",
        datesOverlapping: "Overlapping or invalid dates",
        OnlyWithChildren: "",
        inCaseOfContradiction: "",
        inCaseOfMistake: "",
        orFinishedMiluim: "",
        rulesLinkIsImportant: "",
        rules: "",
        anyOtherIssue: "",
        consultant: "",
        clear: "",
        inCaseOfCalcMistake: "",
        hachraga10nekodotZcootComment: '',
        //HUM
        askForPersonal1: "",
        askForPersonal2: "",
        askForPersonal3: "",
        forAnyQuestion: "",
        miluimConsultant: "",
        ofHUM: ""
    }
};

export function AppStringsByLang(lang: keyof typeof AppStrings) {
    return AppStrings[lang];
}
